

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Configuration provided by user
export const firebaseConfig = {
  apiKey: "AIzaSyA_bPC1nZMFtmeCbirq3ml3X4KZnTNCTjI",
  authDomain: "tagexpress-474310.firebaseapp.com",
  databaseURL: "https://tagexpress-474310-default-rtdb.firebaseio.com",
  projectId: "tagexpress-474310",
  storageBucket: "tagexpress-474310.firebasestorage.app",
  messagingSenderId: "44935876905",
  appId: "1:44935876905:web:c400f9d11519fd7903e738",
  measurementId: "G-FN792HF5C0"
};

// Initialize Firebase only once
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getDatabase(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export default app;